"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textFieldNeoDark = exports.textFieldNeoLight = exports.textFieldNovoDark = exports.textFieldNovo = exports.textField = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const input_const_1 = require("./input.const");
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const textField = {
    input: input_const_1.input,
    label: {
        labelPadding: `0 ${size_const_1.default.default} 0 0`,
        labelMinWidth: 'initial',
    },
    descriptionFontFamily: font_const_1.default.family,
    descriptionFontSize: font_const_1.default.sizeXs,
    descriptionFontStyle: 'normal',
    descriptionFontWeight: font_const_1.default.weightDefault,
    descriptionLineHeight: font_const_1.default.lineHeightXs,
};
exports.textField = textField;
const textFieldNovo = {
    ...textField,
    input: input_const_1.inputNovo,
    descriptionFontFamily: light.label01.fontFamily,
    descriptionFontSize: light.label01.fontSize,
    descriptionFontStyle: 'normal',
    descriptionFontWeight: light.label01.fontWeight,
    descriptionLineHeight: light.label01.lineHeight,
    descriptionColor: light.textColor02,
};
exports.textFieldNovo = textFieldNovo;
const textFieldNovoDark = {
    ...textFieldNovo,
    input: input_const_1.inputNovoDark,
    descriptionColor: dark.textColor02,
};
exports.textFieldNovoDark = textFieldNovoDark;
const textFieldNeoLight = {
    ...textFieldNovo,
    input: input_const_1.inputNeoLight,
    descriptionColor: neoLight.textColor02,
};
exports.textFieldNeoLight = textFieldNeoLight;
const textFieldNeoDark = {
    ...textFieldNovoDark,
    input: input_const_1.inputNeoDark,
    descriptionColor: neoDark.textColor02,
};
exports.textFieldNeoDark = textFieldNeoDark;
